var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ToolbarWithProps } from '../common/Toolbar';
import { Body } from '../root/PageRouter';
import { Grid, Tile, TileHeader, TileComment } from '../common/Tile';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import Loading from '../common/Loading';
import CenteredSign from '../common/CenteredSign';
import { CreateEventModal } from './create-event-modal';
export function eventType(name) {
    return /applied ai conference/i.test(name)
        ? 'conference'
        : /applied ai insider/i.test(name)
            ? 'insiderSeries'
            : 'other';
}
export function EventListPageUI(props) {
    var Layout = function (_a) {
        var children = _a.children;
        // State
        var _b = React.useState(false), modalIsOpen = _b[0], setModalIsOpen = _b[1];
        // Event handlers
        var openModal = function () { return setModalIsOpen(true); };
        var closeModal = function () { return setModalIsOpen(false); };
        return (_jsxs(_Fragment, { children: [_jsx(CreateEventModal, { open: modalIsOpen, onCancel: closeModal, onConfirm: function (data) {
                        if (props.onCreateEvent) {
                            props.onCreateEvent(data);
                        }
                        closeModal();
                    } }, void 0),
                _jsx(ToolbarWithProps, __assign({ cancel: { type: 'back', onClick: props.onBackButton }, action: props.onCreateEvent
                        ? { type: 'add', onClick: openModal }
                        : undefined }, { children: "Events" }), void 0), children] }, void 0));
    };
    if (props.loading) {
        return (_jsx(Layout, { children: _jsx(Loading, {}, void 0) }, void 0));
    }
    if (props.events.length === 0) {
        return (_jsx(Layout, { children: _jsx(CenteredSign, { children: "There are no events" }, void 0) }, void 0));
    }
    var conferences = props.events.filter(function (event) {
        return eventType(event.name) === 'conference';
    });
    var insiderSeries = props.events.filter(function (event) {
        return eventType(event.name) === 'insiderSeries';
    });
    var other = props.events.filter(function (event) {
        return eventType(event.name) === 'other';
    });
    return (_jsx(Layout, { children: _jsx(Body, { children: _jsxs(Grid, { children: [other.length > 0 && (_jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: "Interviews and Chats" }, void 0),
                            _jsx(TileComment, { children: "Explore the latest Fireside Chats, Online Coffee Breaks, Discussions, Interviews and more." }, void 0),
                            _jsx(List, { children: other.map(function (event) { return (_jsx(ListItem, { primary: event.name, secondary: event.description, chevron: true, onClick: event.onClick }, event.id)); }) }, void 0)] }), void 0)),
                    insiderSeries.length > 0 && (_jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: "Applied AI Insiders Series" }, void 0),
                            _jsx(TileComment, { children: "Explore inspirational talks and sessions from BootstrapLabs Applied AI Insiders Series Events" }, void 0),
                            _jsx(List, { children: insiderSeries.map(function (event) { return (_jsx(ListItem, { primary: event.name, secondary: event.description, chevron: true, onClick: event.onClick }, event.id)); }) }, void 0)] }), void 0)),
                    conferences.length > 0 && (_jsxs(Tile, __assign({ span: 12 }, { children: [_jsx(TileHeader, { children: "Applied AI Conferences" }, void 0),
                            _jsx(TileComment, { children: "Explore inspirational talks and sessions from BootstrapLabs Applied AI Conferences" }, void 0),
                            _jsx(List, { children: conferences.map(function (event) { return (_jsx(ListItem, { primary: event.name, secondary: event.description, chevron: true, onClick: event.onClick }, event.id)); }) }, void 0)] }), void 0))] }, void 0) }, void 0) }, void 0));
}
//# sourceMappingURL=event-list-page-ui.js.map